import React from 'react';
import { validationStatements } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';

const ValidationSection = () => {
  return (
    <section className="py-16 md:py-24 bg-violet-50/50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            We understand what you're going through
          </h2>
          <p className="text-lg text-gray-600">
            Caring for a loved one is one of the hardest things you'll ever do.
          </p>
        </div>

        <div className="space-y-4">
          {validationStatements.map((statement, index) => (
            <div 
              key={index}
              className="flex items-start gap-4 p-5 bg-white rounded-2xl border border-violet-100 shadow-sm hover:shadow-md hover:border-violet-200 transition-all"
            >
              <div className="w-6 h-6 mt-0.5 flex-shrink-0">
                <CheckCircle2 className="w-6 h-6 text-violet-500" />
              </div>
              <p className="text-lg text-slate-700 leading-relaxed">
                {statement}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-violet-100 to-fuchsia-100 rounded-2xl px-8 py-6">
            <p className="text-xl md:text-2xl font-semibold text-nursebloc-gradient">
              That's where NurseBloc comes in.
            </p>
            <p className="text-violet-600 mt-2">
              A real nurse partner to help you navigate care, coordinate next steps, and feel confident in the decisions you're making.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValidationSection;
